import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { MDSThemeColorPath, MDSTypography, resolveColor } from '@marqvision/mds-v2';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    minHeight: '100%',
    display: 'grid',
    gridTemplateRows: '1fr auto 2fr',
    backgroundColor: ({ backgroundColor }: { backgroundColor?: MDSThemeColorPath }) =>
      backgroundColor ? resolveColor(backgroundColor) : undefined,
    '&:before, &:after': {
      content: '""',
    },
  },
  textBox: {
    display: 'grid',
    justifyItems: 'center',
    gap: '8px',
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8px',
  },
}));

type Props = {
  title: string;
  description?: string;
  backgroundColor?: MDSThemeColorPath;
};

export const EmptyView = (props: React.PropsWithChildren<Props>) => {
  const { title, description, backgroundColor, children } = props;
  const classes = useStyles({ backgroundColor });

  return (
    <div className={classes.wrapper}>
      <div className={classes.textBox}>
        <MDSTypography variant="T18" weight="medium">
          {title}
        </MDSTypography>
        {description && (
          <MDSTypography variant="T14" color="color/content/neutral/secondary/normal">
            {description}
          </MDSTypography>
        )}
        {children && <div className={classes.action}>{children}</div>}
      </div>
    </div>
  );
};
